module.exports = __webpack_public_path__ + "static/media/gcp-logo.ab6c8ded.svg";